export default "__VITE_ASSET__BMhqlaWq__"